import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../constants/app-constants';
import { DataService } from './data.service';
import { UserCacheService } from './user-cache.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { from } from 'rxjs/internal/observable/from';
import { ApiNameList } from '../../../environments/api-name-list';
import { AppConfigService } from '../../main/app-config.service';

@Injectable()
export class HttpClientService {
    checkRefreshTokenCalled = false;
    private environment: any;
    constructor(
        private http: HttpClient,
        private userCacheService: UserCacheService,
        public dataService: DataService,
        public router: Router,
        private appConfigService: AppConfigService
    ) {
        this.environment = this.appConfigService.getConfig();
    }

    createCustomHeaders(headerParam?: HttpHeaders) {
        if (headerParam) {
            return headerParam;
        } else {
            let headers = new HttpHeaders();
            headers = headers.set('userid', this.userCacheService.getUserData(AppConstants.USERID) ?? '');
            headers = headers.set('authorization', this.userCacheService.getUserData(AppConstants.TOKEN) ?? '');
            headers = headers.set('clientcorrelationid', this.userCacheService.getUserData(AppConstants.CLIENT_CORRELATION_ID) ?? '');
            // if(this.environment.environment === 'local') {
            //    headers = headers.set('sae-portal', 'student');
            // }
            headers = headers.set('sae-portal', 'student');
            return headers.set('Content-Type', 'application/json');
        }
    }

    async tokenRefresh(url: string, method: string, headers?: HttpHeaders, data?: any) {
        try {
            if (url.includes('/secure/')) {
                const token = this.userCacheService.getUserData(AppConstants.TOKEN) ?? '';
                if (token) {
                    const jwtHelper = new JwtHelperService();
                    const expTime = jwtHelper.getTokenExpirationDate(token);
                    const diff = (expTime.getTime() - new Date().getTime()) / 1000;
                    if (diff < this.environment.refreshTokenTimeInterval && !this.checkRefreshTokenCalled) {
                        this.checkRefreshTokenCalled = true;
                        const response: any = await this.http.get(ApiNameList.restApi.baseUrl + ApiNameList.restApi.refreshToken, { headers: headers }).toPromise();
                        this.checkRefreshTokenCalled = false;
                        if (response && response.status === 'SUCCESS') {
                            this.userCacheService.setUserData(AppConstants.TOKEN, response.token);
                            headers = headers.set('authorization', response.token ?? '');
                        }
                    }
                }
            }
            return await this.callHttpMethod(url, method, headers, data);
        } catch(e) {
            // await this.logout();
            return null;
        }
    }

    async callHttpMethod(url: string, method: string, headers?: HttpHeaders, data?: any) {
        if (method === 'Get') {
            return this.http.get(url, { headers: headers }).toPromise();
        } else {
            return this.http.post(url, data, { headers: headers }).toPromise();
        }
    }

    async logout() {
        const participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
        await this.http.get(ApiNameList.restApi.baseUrl + ApiNameList.restApi.logout).toPromise();
        this.userCacheService.eraseAllUserData();
        this.dataService.userLoggedIn(false);
        // this.router.navigate([participantId + '/login']);
        window.location.href = `/logout`;
    }

    get(url: string) {
        const headers = this.createCustomHeaders();
        return from(this.tokenRefresh(url, 'Get', headers));
    }

    post(url: string, data: any, headerParam?: HttpHeaders) {
        const headers = this.createCustomHeaders(headerParam);
        return from(this.tokenRefresh(url, 'Post', headers, JSON.stringify(data)));
    }

    postNodeApiFormData(url: string, data: any) {
        let headers = new HttpHeaders();
        headers = headers.set('userid', this.userCacheService.getUserData(AppConstants.USERID) ?? '');
        headers = headers.set('authorization', this.userCacheService.getUserData(AppConstants.TOKEN) ?? '');
        headers = headers.set('clientcorrelationid', this.userCacheService.getUserData(AppConstants.CLIENT_CORRELATION_ID) ?? '');
        return from(this.tokenRefresh(url, 'Post', headers, data));
    }
}
